























import {Component, Vue} from "vue-property-decorator";
import PickingListTable from "../../pickinglists/shared/component/PickingListTable/index.vue";
import HistoryStockOutSearch from "@/modules/warehouses/HistoryStockOut/components/Search/index.vue";
import PickingListDetail from "@/modules/pickinglists/shared/component/PickingListDetail/index.vue";
import PickingListPrint from "@/modules/pickinglists/shared/component/PickingListPrint/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";
import PLDeliveryTable from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryTable/index.vue";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import PLDeliveryPrint from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryPrint/index.vue";
import PLDeliveryDetail from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryDetail/index.vue";
import {PickingListDeliveryPartnerParams} from "@/modules/pickinglistdeliveries/params";
import PLDeliverySearchPartner
  from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliverySearchPartner/index.vue";
import {getChecking, getTracking} from "@/modules/checking/services";

@Component({
  name: "StockOutDeliveryForPartner",
  components: {
    PLDeliverySearchPartner,
    PLDeliveryDetail,
    PLDeliveryPrint,
    PLDeliveryTable,
    EnumLabel, PickingListPrint, PickingListDetail, HistoryStockOutSearch, PickingListTable
  }
})
export default class extends mixins(CommonMixin) {
  visible = false;
  id = null;
  printObj = {
    id: "picking-list-deliveries-print",
    popTitle: 'Logistic',
    extraCss: `${getPublicPath()}assets/css/print.css`,
  };

  created() {
    PickingListDeliveryStore.clearPickingListDelivery();
    PickingListDeliveryStore.updatePickingListDeliveryParams({...new PickingListDeliveryPartnerParams()});
    PickingListDeliveryStore.listPickingListDeliveryForPartner(PickingListDeliveryStore.params);
  }

  get pickingListDeliveries() {
    return PickingListDeliveryStore.ids.map((id: number) => PickingListDeliveryStore.data[id]);
  }

  onChangePage(pagination) {
    PickingListDeliveryStore.listPickingListDeliveryForPartner({
      ...PickingListDeliveryStore.params,
      page: pagination.current,
      limit: pagination.pageSize
    })
  }

  async seeDetail(id: number) {
    if (isNaN(id)) return;
    this.id = id as any;
    await PickingListDeliveryStore.listBillLadingByPickingListDelivery(this.id);
    this.visible = true;
  }

  async print(id: number) {
    if (isNaN(id)) return;
    this.id = id as any;
    await PickingListDeliveryStore.listBillLadingByPickingListDelivery(this.id);
    this.$print(this.printObj);
  }

  async deletePickingListDelivery(id: number) {
    if (isNaN(id)) return;
    const result = this.pickingListDeliveries.filter(obj => {
      if (obj.billLadings !== null) {
        return obj;
      }
    })

    try {
      const apiResult = result.filter( async obj => {
        await getTracking(obj.code).then(response => response.json()).then(data => {
          for (const i in data.datas) {
            data.datas[i].createdDate = new Date(data.datas[i].ladingDate).toLocaleTimeString('vi-vn', {
              hour: '2-digit',
              minute: '2-digit'
            }) + ' ' + new Date(data.datas[i].ladingDate).toLocaleDateString('vi-vn', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
            data.datas[i].updatedDate = new Date(data.datas[i].ladingDate).toLocaleTimeString('vi-vn', {
              hour: '2-digit',
              minute: '2-digit'
            }) + ' ' + new Date(data.datas[i].ladingDate).toLocaleDateString('vi-vn', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
          }
        }).catch((error) => {
          console.error(error);
        });
      })

      if (apiResult.length !== 0 ) {
        this.$message.error('Xóa bảng kê thất bại do đơn đã có dữ liệu từ phía đối tác.');
      }else {
        await PickingListDeliveryStore.deletePickingListDelivery(id);
        this.$message.success("Xóa bảng kê thành công");
      }
    } catch (e) {
      this.$message.error(e?.response?.data?.message || 'Xóa bảng kê thất bại');
    }
  }

  createDeliveryPartner() {
    this.$router.push({name: "createDeliveryPartner"});
  }
}
